const responseListReports = {
  payload: [
    {
      reportId: 1,
      reportName: "Monetización",
      icon: "https://ibliss-icons-dev.s3.us-east-1.amazonaws.com/reports/monetization.svg",
    },
    {
      reportId: 2,
      reportName: "Empresas",
      icon: "https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/reports/companies.svg",
    },
    {
      reportId: 3,
      reportName: "Histórico de Monetización",
      icon: "https://ibliss-icons-dev.s3.us-east-1.amazonaws.com/reports/billing.svg",
    },  
    {
      reportId: 4,
      reportName: "Gráficas de Felicidad",
      icon: "https://ibliss-icons-dev.s3.us-east-1.amazonaws.com/reports/histogram.svg",
    },
        {
      reportId: 5,
      reportName: "Facturación",
      icon: "https://ibliss-icons-dev.s3.us-east-1.amazonaws.com/reports/purchase.svg",
    },
  ],
};

const responseListConfirmMonetizations = {
  payload: {
    reports: [
      {
          monetizationReportId: 23,
          startDate: "2025-02-22",
          requestCount: 16,
          fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/23_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
          requestStatus: "Pendiente"
      },
      {
          monetizationReportId: 24,
          startDate: "2025-02-25",
          requestCount: 16,
          fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/24_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
          requestStatus: "Pendiente"
      },
      {
          monetizationReportId: 25,
          startDate: "2025-02-26",
          requestCount: 16,
          fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/25_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
          requestStatus: "Pendiente"
      },
      {
          monetizationReportId: 26,
          startDate: "2025-02-27",
          requestCount: 21,
          fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/26_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
          requestStatus: "Pendiente"
      },
      {
          monetizationReportId: 27,
          startDate: "2025-02-27",
          requestCount: 21,
          fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/27_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
          requestStatus: "Pendiente"
      },
      {
          monetizationReportId: 28,
          startDate: "2025-02-27",
          requestCount: 21,
          fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/28_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
          requestStatus: "Pendiente"
      },
      {
          monetizationReportId: 29,
          startDate: "2025-02-27",
          requestCount: 21,
          fileLink: "https://ibliss-files-dev.s3.amazonaws.com/monetization/29_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx",
          requestStatus: "Pendiente"
      }
    ],
    totalRequest: 7
  }
};

const responseConfirmMonetizations = {
  payload: {
    message: "Confirmación del reporte exitoso",
  },
};

const responseHistoricMonetizations = {
  payload: {
    fileName: "ReporteHistoricoMonetizacion.xlsx",
    typeContent: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    content: "UEsDBBQACAgIAFeHxVoAAAAAAAAAAAAAAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbLVUy27CMBD8lcjXKjFwqKqKwKGPY4sE/QBjb4iFY1v2QuHvuw5wgNKKQ" + 
      "nOJ48zszOxa8XC8aUy2hhC1syXrFz2WgZVOabso2cfsNX9gWURhlTDOQsmsY+PRcLb1EDMqtbFkNaJ/5DzKGhoRC+fBElK50AikbVhwL+RSLIAPer17Lp1FsJhj0mCj4TNU" +
      "YmUwe9p9T9IlE94bLQVSKr626kQ0d1WlJSgnVw2VFNEHECrWANiYwgdNSmEKiNRFZNnLhoR3Dc61Zfw6z30TRQDTcmKtfbwjwpEBofEih9PCtKe6dzqLoBXcMg5IqgpU7gMRA2rY" +
      "55yIgG+iIUFO5AmhkZN0cYv3YSzSBbjIMBFvcvz18GMtAqgphnT030JsDD8idJgDt+bMFFKAFvlPZ6QfD85ZtcDu2e9y5LQWjdD2XIZPF5Zz55bd+SeH9v0n+xaMvF06nMOfcgwOOXh"+
      "7l46+AFBLBwjo1lRTXwEAAIkFAABQSwMEFAAICAgAV4fFWgAAAAAAAAAAAAAAAAsAAABfcmVscy8ucmVsc62SwWrDMAyGX8Xo3jjtYIxRt5cy6G2M7gE0W0lMYsvY2pa9/cwuW0sKG+w"+
      "oJH3/h9B2P4dJvVEunqOBddOComjZ+dgbeD49rO5AFcHocOJIBiLDfrd9ogmlbpTBp6IqIhYDg0i617rYgQKWhhPF2uk4B5Ra5l4ntCP2pDdte6vzTwacM9XRGchHtwZ1wtyTGJgn/" +
      "c55fGEem4qtjY9EvwnlrvOWDmxfA0VZyL6YAL3ssvl2cWwfM9dNy5n+ZnP9BDqQoEPBL+oq1QDK4qlcE7pZEMKU/vs6NAtFR+7CSJ/9wO4TUEsHCG5D+iLjAAAASQIAAFBLAwQUAAg" +
      "ICABXh8VaAAAAAAAAAAAAAAAAEAAAAGRvY1Byb3BzL2FwcC54bWydkkFu2zAQRfc9hcB9TMUtgsKgGAROCy9a1ICd7KfUyGZKkQRnLNi9Tc/Si5WSYUVuFgW6+zN/+PVEjro/tq7oMJE" +
      "NvhK3s1IU6E2ord9V4mn7+eajuNfv1DqFiIktUpEPeKrEnjkupCSzxxZolm2fnSakFjiXaSdD01iDj8EcWvQs52V5J/HI6Gusb+IYKM6Ji47/N7QOpuej5+0p5jytHmJ01gDnf9JfrUmBQs" +
      "PFp6NBp+TUVDlog+aQLJ90qeS0VBsDDpc5WDfgCJV8bagVQn9Fa7CJtOp40aHhkAqyP7ESc1F8B8IepxIdJAuexXnsXAzaReKkV+EFqKixML9/OXNwQcnRG+T0yFTbD3o+DGRxPShHnqyvS" +
      "beWHdK3Zg2J/wU+MIgJ6iNwoCneqJYwoNMb9gvFX99dhjaCP0mtvlj/g57iNuRwvFz0dVNt9pCwzm8zPsTYUKuMmlw/v9yD32F9mXlr9GvxfN50fXs3K9+X5bANl56Sr1uu/wBQSwcITttamH0" +
      "BAAAZAwAAUEsDBBQACAgIAFeHxVoAAAAAAAAAAAAAAAARAAAAZG9jUHJvcHMvY29yZS54bWyNkUlvwyAUhP8K4m5j425BtqMuyimRKsVVqt4ofkmsmkVA6uTfF7uJu+XQGzAzH8Mjn+5li97Bukar" +
      "AqdxghEooetGbQr8VM2iG4yc56rmrVZQYKXxtMyFYUJbeLTagPUNOBQwyjFhCrz13jBCnNiC5C4ODhXEtbaS+7C1G2K4eOMbIDRJrogEz2vuOemBkRmJ+IisxYg0O9sOgFoQaEGC8o6kcUq+vB6sd" +
      "GcDgzI6964ZXV3XxV02+EKjlDwv5suhfNSo/ukCcJkf0UxY4B5qFADMH0yYyElZZfcP1QyXNKGXUUKjNK0oZXTCkslLTn7le+DnWttyvhPcNVyhOX91aBnfxss+MOr9uFvu/CJ8y7qB+u5wPvLXNtaWx7P/9KZVesGyjGXX33" +
      "qfAOVwzc/PLz8AUEsHCBTHyzczAQAARgIAAFBLAwQUAAgICABXh8VaAAAAAAAAAAAAAAAAJwAAAHhsL3ByaW50ZXJTZXR0aW5ncy9wcmludGVyU2V0dGluZ3MxLmJpbu2Uv0rDUBTGvzT+qTqoILg4SHESiy2NfzYtTdVKY0LT" +
      "li4OxUYIaFLSiKgoiG8hPoijY0cfwNlJfAAX/VIrKopURzm/cO75zndvbrhJOAZc7CCAjxZjFyGmYbF24XV0SDdydKzhO5Q+deAO1oQ6r0DBEC5HtHiDahS1WIy5FlM5ZqF9e/ffUD7kWDc/k/WC/ekxemGrkkAbM+rc+Mr2ydlPe" +
      "/Z3R+WnRcK/5jffvs2wjfJmpMdwjROksMy/fI05zTGLJPJYRIZekqFjiVeSazL081Qp1hrrNHOOVQYLneqUO5bytl4souK5gdOKlFVvOoHtHjvIajAD1/HCeuj6HiyzVC5lC2WUnJa/d9DxKM1mpNLI+Xt+YPgN51V9PcfcOFDVdO" +
      "Pt7FfDzcQU8wNDZTwpZly7PzQuHgc3Jm8Wzm/pFbtziL/v81bPdnNUrzKqry+I5/fZZw6wD6fTWSrsNw77jIU6VQuHnA/QwNeVJue8Htfm6B+hSWXTiWaiThbSEwRBEARBEARBEARB6IUXUEsHCK4L/YmOAQAALBUAAFBLAwQUAAg" +
      "ICABXh8VaAAAAAAAAAAAAAAAAFAAAAHhsL3NoYXJlZFN0cmluZ3MueG1slVRNj9MwFLzzK6yc4JCPJm0+qjalLbtoD7SILdxfnZfGyLGD7VbV3vgpHDlw2hsXJPLHcLogpGS1gkukPM+bzIxHmS3ONScnVJpJMXdGXuAQFFQWTBzm" +
      "zvvdtZs6i/zZTGtDqDwKM3ei0CFHwT4dcf0wCDOHWBah505lTDP1fU0rrEF7skFhT0qpajD2VR183SiEQleIpuZ+GASxXwMTTj7TLJ+ZfC1rFAYUk5o83zbUygL+YuabfOZ3iAfUzx+3SCwRZ3eScCC1PLGa2UVJ8MyM1NCx4KK/t" +
      "wLrrT/csUaSAslNYXdYyShQ1t6LPmwj671CYgU2HM2A5fZmsLAdUhiY9odvpSIlnOxTSGuk6AQogtoAqeRH6JThmSLv762lUijJFUdqlNXLhs427fca1b+Y+5PB+til/wTP44APwK1+IFfixED1T6+RVhcf79C2Rv2+qYGf9r5gB0n" +
      "YijNtL39zSeMiWfUL0PVtqhugOHdsoTSqEzr5kuMZRKGA2K5ewglJ/ysHVMA9sMhg9PJgq8c9Kuuhlq/FkV80r9mxgAJE+23gOky8JIq9NEkGPVtu1lvy6oqstq+3u/bzgP+SYke/rKxSqfuAIEsHpLCP4jSI925YhmN3jHHqZrQcu3" +
      "EMaZAmYTaJ6P/m9AYVrdov4vGcng4p9IIg8UaTcf9gEkdhfzYO9+W+HCVuNMmoOy5p7EKEIzcuygyzkGIKwd8d3/5v8l9QSwcIkxO6YiQCAACcBAAAUEsDBBQACAgIAFeHxVoAAAAAAAAAAAAAAAANAAAAeGwvc3R5bGVzLnhtbK1WXY" +
      "+bOBR9319h+Z0BE2BCFFJtJoNUqa0qzay0rw6YxKo/kHFmSav+970GEkg76syk5cX29b3nnGtf2yzftVKgJ2YarlWGyU2AEVOFLrnaZfifx9yb43erv5aNPQr2sGfMIlks3u+UNnQrWIZbEtECtSQxIWoNRgCnmgzvra0Xvt8UeyZpc6" +
      "NrpmCm0kZSC0Oz85vaMFo2DlIKPwyCxJeUqwFhIYvXgEhqvhxqr9CyppZvueD22GGdYDp5PyFJXhjd6MreQKSvq4oX7GdBqZ/6tBiRIMXrkEjsB+FFdq25EinyDXvibrPwaqkOMpe2QYU+KJvhAPurZaXVaAmBzy3A4ovS/6ncTcEe49" +
      "5rtWy+oicqwEJcZKGFNsiCGuacwKKoZL3HHRV8a3hHQCUXx94cOkOXwOAnORSGM/o9w4s8wZ/h6ZoGgrgQ5+wj3BtWSygOy4zKYYCG/uOxBnqlFethOr8XvHeGHkkYvz6g0YKXTsXurkva7LYZzuEL4HMw22GCq5K1rMxwEnXoE8RruY" +
      "YFhhKw3K2GF9zcRmmahrPbYHYbJjPyVgFdA4u81aaEC2MsspNptRSsshBu+G7vWqtrx6GthZJeLUtOd1pR4QhOEa+IRN3lk2G7567qi2cF967PcwwdkF4wIR4c2r/VWb87D22F+sP0vnQ1iVw5nbqQ9NDtYfqBw5+i9dgT2PgqWNRWZ/" +
      "yLaBK9KRzRuhbHTwe5ZSbvLszhTL9VEvkRc91NvYBGRrTwl2juTurM/QhixtFbmWZ/hskfNnJSLRe1crYid29l+JNbXjGh2x64gDP3TJ0AZtlWlxe2de/oJQtglKyiB2Efz5MZHvsfWckPMjx7feZP2g5eY/+DO0okcRystR8a27XoYH" +
      "iGv92vb9PNfR5682A996IZi700Xm+8OLpbbzZ5GoTB3ffJI/obT2j37sEGkmjRCPAyQ7KD+IfRluHJoJffrR/InmpPwyT4OyaBl88C4kUJnXvzZBZ7eUzCTRKt7+M8nmiPr3xqA5+QUXy8sFwywRW7lP84tcImwfAXSfinnfDHH6rV/1" +
      "BLBwi4i1CVGwMAAIQJAABQSwMEFAAICAgAV4fFWgAAAAAAAAAAAAAAABMAAAB4bC90aGVtZS90aGVtZTEueG1s7VrNb9s2FL/vrxB0dyXrwx9BncKW7aZt0gSN26FHWqYlxpRokFQSoygwtKddBgzohl0G7LbDMKzACqzYZX9MgBZb90" +
      "eMkvwh2lSbtGmxYbEBWyR/7/HH9x4fn2Vdv3EaYe0YUoZI3NKr10xdg7FPRigOWvr9Qb/S0G9sf3YdbPEQRlCLQQRb+gBGQBtBbX88Rj7UNaEjZlugpYecT7cMg/kCDNg1MoWxGBsTGgEumjQwRhScCN0RNizTrBkRQLG+vVDfw+Ij5iz" +
      "t8DE99AtzzudKh0aTavrFZszDVDsGuKULnSNyMoCnXNcwYFwMtHQze+nG9nVjKYR5iWxBrp+95nJzgdHEyuRoMFwKOo7r1NpL/VaufxPXq/dqvdpSXwYAvi9WWlXorFueM8cWQPmlQne33rWrEr6g397At930LeHtFd7ZwPf73sqGBVB+" +
      "6W7g3U6z05X1uyt8bQNfN9tdpy7hM1CIUTzZQJtuzfYWq11CxgTvKOFN1+nXrTl8hTIK0ZXLx7ws1iJwRGhfADLnAo5ijc+mcAx8gfMARkOKtF0UhCLwpiAmTHSbltk3bfGZvp3sKvMo2IKgIJ13+WyjK+WjMZ+iKW/pt4VWvQB59fLl2" +
      "ZMXZ09+O3v69OzJL/O5N+V2QBwU5d78+PXf33+h/fXrD2+efaPGsyL+9c9fvv79j7ep5xKtb5+/fvH81Xdf/fnTMwW8TcGwCB+gCDLtLjzR7pFILFAxARzSi0kMQoAkCRAKpALY46EEvDsDWIXrQNmED6jIFCrgzeRI4noY0oQjBfBOGE" +
      "nAPUJwh1Dlcu6kcxWXk8SBenKaFHH3ADhWze2tObiXTEXII5VKL4QSzQMsvA0CGEOupWNkAqFC7CFCkl33kE8JI2OuPURaByClSQZoyNVCOygSfpmpCApXS7bZe6B1CFap78JjGSm2BcAqlRBLZrwJEg4iJWMQ4SJyF/BQRfJwRn3J4IwL" +
      "TwcQE603goypZPbpTKJ7R2QYtdv38CySkZSjiQq5CwgpIrtk4oUgmio5ozgsYm+xiQhRoB0QriRB5B2StoUfQFzq7gcI8ott6/siA6kDJB1JqGpLQCLvxxkeA6hS3qaRlF3bFCmjo5MEUmjvQojBCRhBqN2/pcKTKVGTvh2KrLIDVba5De" +
      "RYTdsxZFDL6hqFYxGTQvYQBqSEz95sLfHMQBwBWqb57kQOmZ445ZSpdB/7EymVIppuWjWJfRaBc2k9CIEUVmmbqeN1RuOL7jEhc/QeMvDCMiKxn9s2A4ChOmAGQBQYqnQrRBK1SLqdMrFEKTeWN+3KDcZavROh+J3Fz1rZ436asuejFTyX" +
      "X+qUpZT1AqcM9x8sa7ogiQ+gOEmuqpqrqub/WNWU7eWrWuaqlrmqZT5ZLbMqX4ziXZ5MS1R6y2eMMD7kMwx3WVb4MLH3R33RmTUyoeUdpmkoLufTSbiAguxao4R/jnh4GIKpmKaazRCwueqAaVPCROmkl+rOSq8k2iOjvLdaXdzUFAKAr/" +
      "pF6bXoF4Uaz3tr9dXdu6X6rBWwIgE3U3p+EoXJZBK2gkTdPh+JqnlZLJoKFo3q21gYBa+Iw0kD6f1v18kZiXATIT1K/ZTLL7x76Z4uM6a8bEuxvKZzaZ6WSBTCTSZRCMNQHB7r3Zfs62ZT7WpLSaPe+Bi+NjZzA47llnYi9pztCjU+mLb0" +
      "sfjRJC6jqdDH0kwFcBC3dJ/PDf0+mWVKGe8CFuawbChff4Q4pBpGkYj1ohtwvOJWtermv5dc0/z3Wc5YdzIcj6HPS3pWTTGWK1GOfiA4bZBEkD4MRyfaECf0HhCGcuvV1IAjxPjSmiNEC8G9suJauppvRenPltUWBXgagvmJUkzmOTy7Xt" +
      "IprCNjur4qQ2XCYdC/jFP33UJrSbPkAKmXZrGPd8gXWNlqVq4y1zUb5ttPiQ8/EArUGmpqtppa2dlxiQVBYbpaid2sUm9+4GmwHrVGoa7MWhv/apPhkYj8rqhWE8xZfnPsVJTf3uL/yDwTZL2L7HLKtYSilv7IdNuOZ7lexWy4vYpjO2al" +
      "4bbtStt17WrPrZrdjvVYGIWHUdXN5+6LH/t4JtW42iAd0DUkVvWoZvWbdrNTqzTtdr/idDuNStOrdSrdmlfv9rue22j2H+vacQZ22rbn1HqNSq3qeRWnZqZTN5qVumNZbafebvSc9uPF0wAZiY0nAqJFXX/NJ5FBMkJGxjR7IqBq5U8EzJ" +
      "PhKV98L8ybQbf/AVBLBwhqIZNHjgYAALYgAABQSwMEFAAICAgAV4fFWgAAAAAAAAAAAAAAAA8AAAB4bC93b3JrYm9vay54bWylVctuozAU3c9XIPYE4xiaoKZVClRTqTOq+txEqlzjFCuAGds0qar++1yTkKRKF50OSmz8Oj7n3mNzfLqq" +
      "SueFKy1kPXGDAXIdXjOZi/p54t7dnnsj9/Tkx/FSqsWTlAunYvHFcy0VfSr5xF0FobNS8IvgHyAosOsAYq0nbmFME/u+ZgWvqB7IhtcwMpeqogaa6tnXjeI01wXnpip9jFDkV1TUG4RYfQVDzueC8VSytuK1WYMoXlIDenQhGt2jVewrcB" +
      "VVi7bxmKwagHgSpTCvHWgPA4oPcCrBlNRybgawbsPoQFyA/CD4oG91KPBrSAQUvgibsR1U9E2saIu1kwiZ/G+0AO3g8DfRwi0adk+O56Lk92ujOrRpftPKGrB0nZJqk+XC8HziHkFTLvmHDtU2Z60ooYGHIxS4/snWzlfKyfmctqW5BWI9P" +
      "JyDKBrj0M4Ev09Lw1VNDU9kbcBkXWdSSODsXPM/rVBcd0cBSEJJWUyf9BU1hdOqcuIm8exOA/DssmVUC1o7lzDu3Aymg5tZyvXCyGa2Zy96aNR/MBhllrW/Zbh+P5SwUnEf3CujHHi/SC8hkDf0BcIKycs3R+oC4hYMH2um4uDxLUtTnJIj" +
      "4kVolHqEnCfeOEzOvWyEouh8GOE0xO+uvRBiJmlrik1ILfTEJdEnQ7/oqh8JUNyKfEfjDW0e75Oif96tYJvMe8GXepdb23RWD6LO5XLiepgEGGS9bju65rJrPYjcFGAPgsm27ycXz4Wx2pGdCC623IBTlE3TiJwF3hSjxCMYpRACFHgoCRH" +
      "B2WiEp1nHyd8j1aWpr526825KjYTrqevqogxWje0W6iLvXLo/OaEla8sP8+Gq1QZyCnYRec7rveW427/flMFacLqtun3GAcJjO4OvzKU2XQ1eFSAuIGh6hMbEQ9kw9MhojL0RGWIvISnOwqMszc7C97XP471DxAqqzK2ibAHfjWs+P6OaW0G" +
      "WBYCvy24rv1918hdQSwcIQBR/wugCAAB7BgAAUEsDBBQACAgIAFeHxVoAAAAAAAAAAAAAAAAaAAAAeGwvX3JlbHMvd29ya2Jvb2sueG1sLnJlbHO9kl1rwyAUQP+K3PfFJPtgjNq+jEJft+4HiN7E0ETFe7ut/34ugzWFBvYQ9qLIxXMO4mr" +
      "zOfTiHRN1wSuoihIEehNs51sFb/vtzSMIYu2t7oNHBT7AZr16wV5zvkGuiyQywpMCxxyfpCTjcNBUhIg+T5qQBs35mFoZtTnoFmVdlg8yTRlwyRQ7qyDtbAVir1OLrOAjpAM5RCY5blWR4Xl8ivgXdWiazuBzMMcBPV8pkL8CkNdj6vmY+t9j" +
      "bs8xnD0ox3XxRxmpcw135wbiU4+0tP2HOqe/n+idTmhfOeVvu3zFFP4dIy++//oLUEsHCNk/ItDrAAAARAMAAFBLAwQUAAgICABXh8VaAAAAAAAAAAAAAAAAGAAAAHhsL3dvcmtzaGVldHMvc2hlZXQxLnhtbK1Yy3LbNhTd9ytQTpbh+yFSI" +
      "ylDUVLjxplm6jRdQyQkYUwSDAjacjv+mHxAV9116x/rBUm9SKZjJ/XYJAGce+7FfeDhyZt9lqI7wkvK8qliaoaCSB6zhObbqfLbx5XqK29mP0zuGb8td4QIlMXjq23OOF6nZKrsTQfHaM/h14I/W4HHuKLJVPlztFy4jm35quMGjuosAl8Nwo" +
      "Wjrjx/ZTjRyhytrEfAZ2leTpWdEMVY18t4RzJcaqwgOYxsGM+wgCbf6mXBCU5qI7JUtwzD0zNM85ZhzJ/DwTYbGpMFi6uM5KIh4STFAmZf7mhRHtiy+Dl0Gea3VaHGLCuAYk1TKh5q0gNN7Z4eU0Zjzkq2ERpItjb1pxfogY7jI1N/fs+iMR2Y" +
      "4B2V4T1RWd/I5R65rBOZ/Y1k3pHMVmaThEJEZANxspkqoTm+thV9NqkFPlFyX559I4HXNyQlsSCQaaaCZHquGbuVg1fQZUhRvSe7qmP3gaM1LknE0t9pInZAAEmfkA2uUvEru39L6HYnoNfRHJiljOA4eViQMoaUAWqttitmaVk/UUbz2oYM7" +
      "+v3mpRiRQEpeEUUFFelYFmrqem6b9WONNMI7JHb8jVMVstk/aeor7mu4/kdWbuVtV9iRaB5nmN41iWV01I5L6CybM0yuza5LZH7AiJvyDFeS+S9ZHL2oJ9GLdXou6Plt0z+y0WDVjR4jhGleJDLrXnytaXZtmXYZiduMpebTDQGiXY0SUjeDZy" +
      "rGZcsx3x+SULbzmAqmYeUlh/PTybznExv6q2u4gUWeDbh7B7x2iNlgeUOYo4l/2C9gjESG0pwXVnQX0Lv3cyZ6HeSvUXM+4jgEhH1EfYlYtFHmMYlZNmHWJeI1QCJeQn5aQDSYXk7AOlYezUA6Tjl5wbinEPcS8i7BmKfQy4R133EySk6BPMYU" +
      "esYroNRUtBoSL1OvAYgo07ABiB+J2IDkE7Yl32I1QnqagDSDdkApBuyBpJfKIIfraPt6hxnNrns+oanBc2i0AnhgGJ72P2narH7Mt1yGYB0NEd9SM/9AyydOC8HIF33D0C67h+AdLLlrd1zvznofnvI/bDdBIbvO5YbwG83BgPa/U4M9LMFLoHn" +
      "J5zSpDmdophVcj2Tyi6HkHgoYG8QZC+uSb4VOwXBWZVjwUBrSsry4w7nv/Dl5wqnCsJpyu7nKc5vm8Vzx+6v8qIS7wGIt+TYueSc8fNOIjs+UiH3oXpwjCKcCzAiQTeVVJjgFgXljlF8GEwIfHMMhzVOSgQXC3gBFuUMQRsEMyqBmoIKDidp0eo" +
      "4kr9/+rKnGT4Mg/YUpU9/gRRBWT3GOjpIDsxCdmVFrQRKCOjLz/XZ8toaX5uG47sj7+y6EkR+5I/shWotRwu4roQrNbRWc9U3gsDyRsswCKJH8L08/1cpNmGJgDXi2Jrol0HpdcDuVYAr32O+pRDNlGzqzQmOILw5b9bfghX1lzwtMQFb46G1g8" +
      "Mz4c12hjaMiUNDb3hviKgKVGBw5w39g9THCsYpbIG19qlSMC44pgL0jeWE+VViSmGZNaWo36jiFDwRRUsvdN2RGozmkeqs/UANF3NPXQRRYEdhOLcXq8ezG8533G/qC9xsAiTjr6b7QVH2PD1kH5Pz6+EQe1sxKS3F/1QQULJM5nbMOIdrCSu1Yy" +
      "l8YBxt8B3jr9vcJ+jpn5xCbkJwCEpBLqmlIYdTjKRRvVpo6DG6aoqHn2rh0PN1TqiElvU1esDocyXVlLBExOCJUwHypy85yuDiD14EOrCE5vVdN6ZPf+eoJFvQAC+oWxJLjZRpZ+UDB9wwcuaBujSWAZSP4ahhNHfUuWXOrUW4CC1/9NgG41Q0+" +
      "2y8mUU4jSsw+cdX4StrDA/YmeoBeHXRdQnP3lnjd20F19Cmt4H3ynAguaAX0r151smvH/+/MfsXUEsHCLCXePSiBQAAEhEAAFBLAwQUAAgICABXh8VaAAAAAAAAAAAAAAAAIwAAAHhsL3dvcmtzaGVldHMvX3JlbHMvc2hlZXQxLnhtbC5yZWxzj" +
      "Y/BCsIwEER/JezdpPUgIk29iNCr1g+I6bYNtpuQrKJ/b45WPHgchnm8qfbPeRIPjMl50lDKAgSS9Z2jQcOlPa62IBIb6szkCTWQh31dnXAynBdpdCGJjKCkYWQOO6WSHXE2SfqAlJvex9lwjnFQwdibGVCti2Kj4icDlkzRdBpi05UgWhMHZA1Sq" +
      "hAdMcYzMme99J1LeXWUB6+A/8j4vncWD97eZyT+4fTNB1VXavG8fgNQSwcIvp22MLMAAAA/AQAAUEsDBBQACAgIAFeHxVoAAAAAAAAAAAAAAAAYAAAAeGwvd29ya3NoZWV0cy9zaGVldDIueG1snZRZj5swEIDf+yssvxPOkAQBqxxddR8qVasez" +
      "44xYMXG1HaSXVX97x1IQqLSStmVOGbM+JvTpA8vUqAD04arJsP+xMOINVQVvKky/O3rozPHD/mH9Kj0ztSMWSRp8lQ1SpOtYBl+8SNC0YuGK4A7xPBI9rzI8K/lYh7Em9XMCXxv5kQLb+rMYz92vGk8X6296OMm8n+DvRSNyXBtbZu4rqE1k8RMVM" +
      "sa+FIqLYkFVVeuaTUjRR+EFG7gebErCW/OhETfw1BlySnbKLqXrLEniGaCWMje1Lw1F5qk9+Ak0bt961AlW0BsueD2tYdeMH15RiTJqVZGlXYCO88xjdNbuAuX0IE0zu8ujB9BggfetfeKCt7Jmg6s4AoL3wmLB1iI87Tg0JFOQZqVGV76ySrEbp" +
      "72G75zdjQ3MurGcavUrlOeYNg8IBgmGO0aiQi8DmzNhMjwCiI1P3smiAB0B8qtfKE/9t39otGWGLZW4gcvbA3nAo5FwUqyF/ZZHT8xXtUWVqNJBHXoepwUrxtmKAwVBDO5Rr4hluSpVkcE/fMhlJZ00+4nwX825intTJdgCyswj+aU3SGfpe4BQqZ" +
      "ni9XYYj5YuOBxcBu8wW0wgk7/DQ3fAA1H0PgvqHtTrJZU7DPRFW8MEqzsWTOM9KnmvWxV20tTjLbKWiUvWg0jxvTJOyqVshela/zwD8v/AFBLBwiI63w7CwIAAPYEAABQSwECFAAUAAgICABXh8Va6NZUU18BAACJBQAAEwAAAAAAAAAAAAAAAAAA" +
      "AAAAW0NvbnRlbnRfVHlwZXNdLnhtbFBLAQIUABQACAgIAFeHxVpuQ/oi4wAAAEkCAAALAAAAAAAAAAAAAAAAAKABAABfcmVscy8ucmVsc1BLAQIUABQACAgIAFeHxVpO21qYfQEAABkDAAAQAAAAAAAAAAAAAAAAALwCAABkb2NQcm9wcy9hcHAue" +
      "G1sUEsBAhQAFAAICAgAV4fFWhTHyzczAQAARgIAABEAAAAAAAAAAAAAAAAAdwQAAGRvY1Byb3BzL2NvcmUueG1sUEsBAhQAFAAICAgAV4fFWq4L/YmOAQAALBUAACcAAAAAAAAAAAAAAAAA6QUAAHhsL3ByaW50ZXJTZXR0aW5ncy9wcmludGVyU2" +
      "V0dGluZ3MxLmJpblBLAQIUABQACAgIAFeHxVqTE7piJAIAAJwEAAAUAAAAAAAAAAAAAAAAAMwHAAB4bC9zaGFyZWRTdHJpbmdzLnhtbFBLAQIUABQACAgIAFeHxVq4i1CVGwMAAIQJAAANAAAAAAAAAAAAAAAAADIKAAB4bC9zdHlsZXMueG1sUEs" +
      "BAhQAFAAICAgAV4fFWmohk0eOBgAAtiAAABMAAAAAAAAAAAAAAAAAiA0AAHhsL3RoZW1lL3RoZW1lMS54bWxQSwECFAAUAAgICABXh8VaQBR/wugCAAB7BgAADwAAAAAAAAAAAAAAAABXFAAAeGwvd29ya2Jvb2sueG1sUEsBAhQAFAAICAgAV4fF" +
      "Wtk/ItDrAAAARAMAABoAAAAAAAAAAAAAAAAAfBcAAHhsL19yZWxzL3dvcmtib29rLnhtbC5yZWxzUEsBAhQAFAAICAgAV4fFWrCXePSiBQAAEhEAABgAAAAAAAAAAAAAAAAArxgAAHhsL3dvcmtzaGVldHMvc2hlZXQxLnhtbFBLAQIUABQACAgIA" +
      "FeHxVq+nbYwswAAAD8BAAAjAAAAAAAAAAAAAAAAAJceAAB4bC93b3Jrc2hlZXRzL19yZWxzL3NoZWV0MS54bWwucmVsc1BLAQIUABQACAgIAFeHxVqI63w7CwIAAPYEAAAYAAAAAAAAAAAAAAAAAJsfAAB4bC93b3Jrc2hlZXRzL3NoZWV0Mi54bWxQSwUGAAAAAA0ADQBsAwAA7CEAAAAA"
  },
};

const responseListStartMonetizations = {
  payload: {
    totalToMonetize: 237200,
    totalRequest: 16,
    previewData: [
      {
        displayName: "Carlos Angulo",
        emailAddress: "core@ibliss.com",
        identificationNumber: 1.212112,
        requestDate: "04/01/2025",
        amountToMonetize: 12.2333,
      },
      {
        displayName: "jorge Luna",
        emailAddress: "core@ibliss.com",
        identificationNumber: 1.212112,
        requestDate: "04/01/2025",
        amountToMonetize: 12.2333,
      },
      {
        displayName: "Ricardo Mendoza",
        emailAddress: "core@ibliss.com",
        identificationNumber: 1.212112,
        requestDate: "04/01/2025",
        amountToMonetize: 12.2333,
      },
      {
        displayName: "Camilo Pardo",
        emailAddress: "core@ibliss.com",
        identificationNumber: 1.212112,
        requestDate: "04/01/2025",
        amountToMonetize: 12.2333,
      },
      {
        displayName: "Camilo Sanchez",
        emailAddress: "core@ibliss.com",
        identificationNumber: 1.212112,
        requestDate: "04/01/2025",
        amountToMonetize: 12.2333,
      },
      {
        displayName: "Franco Escamilla",
        emailAddress: "core@ibliss.com",
        identificationNumber: 1.212112,
        requestDate: "04/01/2025",
        amountToMonetize: 12.2333,
      },
      {
        displayName: "Carlos Angulo",
        emailAddress: "core@ibliss.com",
        identificationNumber: 1.212112,
        requestDate: "04/01/2025",
        amountToMonetize: 12.2333,
      },
      {
        displayName: "Carlos Angulo",
        emailAddress: "core@ibliss.com",
        identificationNumber: 1.212112,
        requestDate: "04/01/2025",
        amountToMonetize: 12.2333,
      },
    ],
  },
};

const responseEmailSend = {
  payload: "app@ibliss.com",
};

const responseReportMonetization ={
  payload: "https://ibliss-files-dev.s3.amazonaws.com/monetization/report/66_LUCASIANLABSS.A.S.ambientedesarrollo.xlsx"
}

export const service = {
  getListReports: () =>
    new Promise((resolve) => {
      setTimeout(resolve({ data: responseListReports }), 1000);
    }),

  getListStartMonetizations: () =>
    new Promise((resolve) => {
      setTimeout(resolve({ data: responseListStartMonetizations }), 1000);
    }),

  getListConfirmMonetizations: () =>
    new Promise((resolve) => {
      setTimeout(resolve({ data: responseListConfirmMonetizations }), 1000);
    }),

  postConfirmMonetizations: () =>
    new Promise((resolve) => {
      setTimeout(resolve({ data: responseConfirmMonetizations }), 1000);
    }),

  getEmailSend: () =>
    new Promise((resolve) => {
      setTimeout(resolve({ data: responseEmailSend }), 1000);
    }),

  generateMonetizationReport: () =>
    new Promise((resolve) => {
      setTimeout(resolve({ data: responseReportMonetization }), 1000);
    }),

  postHistoricMonetization: () =>
    new Promise((resolve) => {
      setTimeout(resolve({ data: responseHistoricMonetizations }), 1000);
    }),
};
